export async function postLoginWithLegacyFallback(send, payload) {
  try {
    return await send(payload);
  } catch (error) {
    const respostaVazia =
      error?.response?.data == null || error.response.data === "";
    const loginInicial =
      !payload.codigoAutenticacaoDoisFatores &&
      !payload.canalAutenticacaoDoisFatores &&
      !payload.passkeyAutenticacaoDoisFatores;
    if (error?.response?.status !== 403 || !respostaVazia || !loginInicial) {
      throw error;
    }
    return send({ email: payload.email, senha: payload.senha });
  }
}
